import { createContext } from "react";
import { User } from "../models/userModel";

export interface AuthContextInterface {
  user: User | null;
  token: string | null;
  isLoading: boolean;
  onLauched: boolean;
  login: any;
  logout: () => void;
  refreshUser: () => void;
  /* eslint-disable */
  updateUser: (data: any) => void;
}

export const authContextDefaults: AuthContextInterface = {
  user: null,
  isLoading: true,
  token: null,
  onLauched: false,
  login: () => {},
  logout: () => {},
  refreshUser: () => {},
  updateUser: () => {
    //function to clear Data
  },
};

export const AuthContext =
  createContext<AuthContextInterface>(authContextDefaults);
